import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Box, CircularProgress, Typography } from '@mui/material';

const SubscriptionRoute = ({ children }) => {
    const { isAuthenticated, user, isLoading } = useAuth();
    
    // Show loading while checking auth status
    if (isLoading) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50vh', flexDirection: 'column' }}>
                <CircularProgress />
                <Typography variant="body1" sx={{ mt: 2 }}>Verifying account status...</Typography>
            </Box>
        );
    }
    
    // If not authenticated, redirect to login
    if (!isAuthenticated) {
        return <Navigate to="/login" />;
    }
    
    // Check for admin users who should always have access
    if (user.role === 'admin') {
        console.log('Admin user detected - granting access');
        return children;
    }
    
    // Check for users with active subscriptions (from standard API check)
    if (user.hasActiveSubscription) {
        console.log('User has active subscription via API check - granting access');
        return children;
    }
    
    // Check for admin-set subscription in user.subscription object
    if (user.subscription && user.subscription.status === 'active') {
        console.log('User has admin-set active subscription - granting access');
        return children;
    }
    
    // If no active subscription, redirect to subscription page
    console.log('User lacks active subscription, redirecting to subscription page');
    return <Navigate to="/subscription" />;
};

export default SubscriptionRoute;
